<template>
  <div class="box-description">
	<div class="row">
		<div class="col-12 col-service-title">
			<h5>Paquetes de movilidad con SkyCel</h5>
		</div>

		<!-- BENEFICIOS -->
		<div class="col-12 col-benefits">
			<div class="row">
			<div class="order-0 col-12 col-subtitle">
				<h5>
				Cobertura nacional en la mayor parte de México con red propia 4.5
				G
				</h5>
			</div>

			<div class="order-1 col-6 col-sm-6 col-md-4 col-benefit">
				<div class="icons"><i class="fad fa-mobile-alt"></i></div>
				<p class="txt">Llamadas de alta calidad<br />y red continua.</p>
			</div>

			<div class="order-4 order-sm-2 col-12 col-sm-6 col-md-4 col-benefit">
				<div class="icons browsers">
				<i class="fab fa-chrome"></i><i class="fab fa-firefox-browser"></i
				><i class="fab fa-edge"></i><i class="fab fa-safari"></i>
				</div>
				<p class="txt">La mejor experiencia<br />de navegación.</p>
			</div>

			<div class="order-3 col-6 col-sm-6 col-md-4 col-benefit">
				<div class="icons signal"><i class="far fa-signal"></i></div>
				<p class="txt">
				Señal disponible en pueblos<br />mágicos y lugares remotos.
				</p>
			</div>

			<div class="order-4 col-12 col-subtitle v2">
				<h5>Conoce nuestros paquetes y contrata ya mismo</h5>
			</div>
			</div>
		</div>
		<!-- BENEFICIOS -->

		<offers-slider class="col-12 col-carousel" />
	  
	</div>
  </div>
</template>

<script>
	import offersSlider from '../../daniel/offers-slider.vue';

	export default {

  		components: { offersSlider },

		data() {
			return {
				// == Carousel options ==
				// == ==
			};
		},

	};
</script>
